import { render, staticRenderFns } from "./IgnoreDiscounts.vue?vue&type=template&id=31861b57&"
import script from "./IgnoreDiscounts.vue?vue&type=script&lang=js&"
export * from "./IgnoreDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./IgnoreDiscounts.vue?vue&type=style&index=0&id=31861b57&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports